module.exports = __webpack_public_path__ + "img/logo-hk.fe22e391.png";